import {getCurrentYear} from '../../utils/commons'
import BestHouseholdPicksLogo from './logo'
import {bestHouseholdPicksStylesUK, bestHouseholdPicksStylesUS} from './styles'

const baseConfig = {
  domainName: 'besthouseholdpicks' as const,
  domainType: 'picks' as const,
  siteName: 'Best Household Picks',
  favicon: '/favicons/besthouseholdpicks.png',
}

const localeConfigs = {
  us: {
    measurementId: 'G-T2VLJ65WYT',
    camelCaseUrl: 'BestHouseholdPicks.com',
    logo: <BestHouseholdPicksLogo className="size-9 shrink-0 tablet:size-7" locale="us" />,
    title: (category: string, count: string) =>
      `Top ${count} ${category} ${getCurrentYear()} in the US | BestHouseholdPicks.com - Reviews & Guides`,
    description: (_category?: string, _count?: string) =>
      `At BestHouseholdPicks.com, we showcase the finest household essentials for ${getCurrentYear()}. Benefit from our expert reviews and detailed product insights to make smart choices for your home.`,
    styles: bestHouseholdPicksStylesUS,
  },
  uk: {
    measurementId: 'G-8JW8THNED5',
    camelCaseUrl: 'BestHouseholdPicks.co.uk',
    logo: <BestHouseholdPicksLogo className="size-9 shrink-0 tablet:size-7" locale="uk" />,
    title: (category: string, count: string) =>
      `Top ${count} ${category} ${getCurrentYear()} in the UK | BestHouseholdPicks.co.uk – Reviews & Guides`,
    description: (_category?: string, _count?: string) =>
      `At BestHouseholdPicks.co.uk, we showcase the finest household essentials for ${getCurrentYear()}. Benefit from our expert reviews and detailed product insights to make smart choices for your home.`,
    styles: bestHouseholdPicksStylesUK,
  },
}

export const createConfig = (locale: string = 'us') => {
  const localeConfig = localeConfigs[locale as keyof typeof localeConfigs] || localeConfigs.us
  return {
    ...baseConfig,
    ...localeConfig,
  }
}
